import { AufnahmePunktDocument } from "src/app/data-model";
import { EvalFunc } from "../evaluation.service";

export const phDurchschnittEval: EvalFunc = (bp: any, i?: number, key?: string) => {
    const b = bp as AufnahmePunktDocument;
    if (i !== undefined || !b.extendedHeader.ph) return undefined;

    const werte: number[] = [];
    if (b.extendedHeader.ph.wert1 !== undefined && b.extendedHeader.ph.wert1 !== null && b.extendedHeader.ph.wert1 >= 0 && b.extendedHeader.ph.wert1 <= 14) {
        werte.push(b.extendedHeader.ph.wert1);
    }
    if (b.extendedHeader.ph.wert2 !== undefined && b.extendedHeader.ph.wert2 !== null && b.extendedHeader.ph.wert2 >= 0 && b.extendedHeader.ph.wert2 <= 14) {
        werte.push(b.extendedHeader.ph.wert2);
    }

    if (werte.length === 0) return undefined;

    let sum = 0;
    werte.forEach(v => sum += v);
    return sum / werte.length;
};
